<template>
  <div id="page-product-ipr-details">

    <div class="mb-4">
      <h1>Product: {{ model.ProductCode }}</h1>
    </div>

    <product-form
        v-model="model"
        :loading="loading"
        ref="form"
        card-title="Edit Product"
        :ProductCompanyType="ProductCompanyType"
        :ProductCompanyType_FK="ProductCompanyType_FK"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
            @click="$router.back()"
            class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              @click="save"
              class="my-4"
              color="light"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ProductForm from "@/views/pages/products-ipr/ProductForm";
import ViewModelMixin from "@/components/mixins/ViewModelMixin";
import NotificationMixin from "@/components/mixins/NotificationMixin";
import IprProductCompanyTypeMixin from "@/components/mixins/IprProductCompanyTypeMixin";

export default {
  name: "ProductIprEdit",
  components: {
    ProductForm
  },
  mixins: [ViewModelMixin,NotificationMixin,IprProductCompanyTypeMixin],
  data() {
    return {
      loading: false,
      modelEntity: this.$api[this.companyTypeApiModel('productsIpr')],
    };
  },
  methods: {
    getParams() {
      const params = {
        ...this.model
      }

      const references = [
        'LIORiskCode_FK',
        'LloydsRiskCode_FK',
        'InsuranceType_FK',
        'Wording_FK',
        'FrontJacket_FK',
        'RearJacket_FK',
        'StandardClause_FK',
      ]

      references.forEach((ref) => params[ref] = this.getReferenceId(ref))

      return params;
    },
    getReferenceId(fieldName) {
      if (!this.model[fieldName]) {
        return null;
      }

      return this.model[fieldName].id || null;
    },
    async save() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();

      //  return;
      try {
        const {data} = await this.$api[this.companyTypeApiModel('productsIpr')].update(this.id, params);
        this.notifySuccess('Product updated');
        this.$router.back();
      } catch (e) {
        this.notifyError('Product failed to be created');
        console.error(e)
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
